import styled from '@emotion/styled';
import { Command } from 'lucide-react';
import Item from 'modules/template-editor/ui/hooks/modals/tip/item';
import { Items } from 'modules/template-editor/ui/hooks/modals/tip/style';
import { useCallback, useState } from 'react';
import UDCard from 'ud-ui/components/card';
import { Divider } from 'ud-ui/components/divider';
import Modal from 'ud-ui/components/modal';
import UDText from 'ud-ui/components/text';
import { BulletList } from './style';

const cardStyle = { background: '#f6f6f6', border: 'none', marginTop: 16, marginBottom: 20 };
const textStyle = { color: '#52525b' };

function useTextBlockHelpModal() {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    modal: (
      <Modal show={isOpen} onClose={close}>
        <div style={{ width: 720, maxWidth: '100%' }}>
          <Modal.Header title="Текстовые блоки" />
          <Modal.Body>
            <UDCard style={cardStyle}>
              <UDText isNew type="text-1" style={textStyle}>
                Текстовые блоки можно изменять по высоте и ширине. При публикации шаблона в этом блоке будет отображен текст
                соответствующего элемента. Размер его шрифта зависит от трех показателей:
              </UDText>
              <BulletList>
                <li>
                  <UDText isNew type="text-1" style={textStyle}>
                    длина текста
                  </UDText>
                </li>
                <li>
                  <UDText isNew type="text-1" style={textStyle}>
                    ширина блока
                  </UDText>
                </li>
                <li>
                  <UDText isNew type="text-1" style={textStyle}>
                    высота блока
                  </UDText>
                </li>
              </BulletList>
              <UDText isNew type="text-1" style={{ ...textStyle, marginTop: 8, display: 'block' }}>
                Например: если вы добавите два блока <b>Команда №1</b> и <b>Команда №2</b>, указав одинаковую ширину и длину, то в
                случае если длина названия <b>Команда №1</b> будет длиннее чем <b>Команда №2</b>, то их размер шрифта при публикации
                шаблона могут различаться, так как нужно уместить весь текст в блок.
              </UDText>
            </UDCard>
            <Divider type="horizontal" color="#ededed" style={{ marginBottom: 20 }} />
            <UDText isNew type="title-1" style={{ marginBottom: 16 }}>
              Комбинация кнопок
            </UDText>
            <Items>
              <Item
                text={'Перетаскивание сетки'}
                windows={{ icon: <TextIcon>ctrl</TextIcon>, text: '+ клик' }}
                mac={{
                  icon: <Command size={16} />,
                  text: '+ клик',
                }}
              />
            </Items>
          </Modal.Body>
        </div>
      </Modal>
    ),
    open,
    close,
  };
}

export default useTextBlockHelpModal;

const TextIcon = styled.span`
  font-family:
    SF Pro Text,
    serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  vertical-align: bottom;
  color: ${({ theme }) => theme.colors.NarcissusYellow};
`;
